import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-wa-details',
	templateUrl:'./WaDetailsPage.html',
	styles: [],
	styleUrls:['./WaDetailsPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class WaDetailsPage
{
	mdContent_322 = `\`\`\`java
import com.jwebmp.webawesome.components.details.WaDetails;
\`\`\``;
	mdContent_323 = `\`\`\`java
new WaDetails<>()
\`\`\``;
	mdContent_324 = `\`\`\`java
var d1 = new WaDetails<>();
d1.setSummary("Section 1");
d1.setName("faq");
d1.setText("Content 1");

var d2 = new WaDetails<>();
d2.setSummary("Section 2");
d2.setName("faq");
d2.setText("Content 2");
\`\`\``;
}
